import React, { useEffect, useState } from "react";
//Importar íconos de Material UI.
import { MoreVert } from '@mui/icons-material/';
import Tooltip from '@mui/material/Tooltip';

// AssingOperator: Componente que renderiza la vista del operador asignado,
// y además 

const AssingOperator = ({ operatorAsinged, containerAsignRef, openMenuChatAsign, setOpenMenuChatAsing }) => {

    const [operador, setOperador] = useState('Sin Asignar'); //Estado para actualizar el operador asignado.

    useEffect(() => {
        if (operatorAsinged) setOperador(operatorAsinged);
        else setOperador('Sin Asignar');

    }, [operatorAsinged]);

    return (
        <div className="container-asing">
            <div className="container-asing__text">
                <span> <strong>Asignado a:</strong> </span>
                <label> {operador}</label>
            </div>

            <Tooltip title="Asignar un nuevo operador" >
            <button className="container-asign__btn" onClick={() => setOpenMenuChatAsing(!openMenuChatAsign)}
                ref={containerAsignRef}>
                <MoreVert sx={{ fontSize: "24px" }} />
            </button>

            </Tooltip>

         

        </div>
    )
};

export default AssingOperator;